import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export function getCompositionStats(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/mails/vesselComposition/stats',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/statistics/composition.js